import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiMoreVertical } from "react-icons/fi";
import { BsCalendar } from "react-icons/bs";
import { AiOutlineCheckCircle } from "react-icons/ai";
import EditTaskModal from "../../modals/dashboard/employee-dashboard/EditTaskModal";
import DeleteProjectModal from "../../modals/dashboard/employee-dashboard/DeleteProjectModal";



export default function EmployeeProjectsCard(){

const [showEdit,setShowEdit]=useState(false)
const [showDelete,setShowDelete]=useState(false)

const projects=[
{
title:"Office Management",
leader:"Anthony Lewis",
img:"/assets/img/users/user-32-1.jpg",
deadline:"14 Jan 2024"
},
{
title:"Office Management",
leader:"Anthony Lewis",
img:"/assets/img/users/user-33-1.jpg",
deadline:"14 Jan 2024"
}
]

return(

<Card className="dashboard-card h-100">

<Card.Header className="d-flex justify-content-between align-items-center card-header-custom">

<h5>Projects</h5>

<Dropdown>

<Dropdown.Toggle size="sm" variant="light">
Ongoing Projects
</Dropdown.Toggle>

<Dropdown.Menu align="end">
<Dropdown.Item>All Projects</Dropdown.Item>
<Dropdown.Item>Ongoing Projects</Dropdown.Item>
</Dropdown.Menu>

</Dropdown>

</Card.Header>

<Card.Body>

<div className="row">

{projects.map((p,i)=>(

<div className="col-md-6" key={i}>

<div className="project-inner-card">

<div className="d-flex justify-content-between mb-3">

<h6>{p.title}</h6>

<Dropdown>

<Dropdown.Toggle className="p-0 border-0" variant="link">
<FiMoreVertical/>
</Dropdown.Toggle>

<Dropdown.Menu align="end">

<Dropdown.Item onClick={()=>setShowEdit(true)}>
Edit
</Dropdown.Item>

<Dropdown.Item onClick={()=>setShowDelete(true)}>
Delete
</Dropdown.Item>

</Dropdown.Menu>

</Dropdown>

</div>

<div className="d-flex align-items-center mb-3">

<img src={p.img} className="avatar"/>

<div className="ms-2">

<h6 className="fw-normal mb-0">{p.leader}</h6>
<span className="small text-muted">Project Leader</span>

</div>

</div>

<div className="d-flex align-items-center mb-3">

<div className="icon-circle">
<BsCalendar/>
</div>

<div className="ms-2">
<h6 className="fw-normal mb-0">{p.deadline}</h6>
<span className="small text-muted">Deadline</span>
</div>

</div>

<div className="task-box">

<div className="d-flex align-items-center">

<span className="task-icon">
<AiOutlineCheckCircle/>
</span>

<p className="mb-0">Tasks : <b>6</b> /10</p>

</div>

<div className="avatar-group">

<img src="/assets/img/profiles/avatar-06-1.jpg"/>
<img src="/assets/img/profiles/avatar-07-1.jpg"/>
<img src="/assets/img/profiles/avatar-08-1.jpg"/>

<span className="more">+2</span>

</div>

</div>

<div className="time-box">

<p className="mb-0">Time Spent</p>
<h6>65/120 <span>Hrs</span></h6>

</div>

</div>

</div>

))}

</div>

</Card.Body>

<EditTaskModal show={showEdit} setShow={setShowEdit}/>
<DeleteProjectModal show={showDelete} setShow={setShowDelete}/>

<style>{`

.dashboard-card{
border-radius:5px;
border:2px solid #e5e7eb;
}

.project-inner-card{
border:1px solid #e5e7eb;
border-radius:8px;
padding:15px;
}

      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

.avatar{
width:36px;
height:36px;
border-radius:50%;
object-fit:cover;
}

.icon-circle{
width:36px;
height:36px;
background:#fff1ea;
color:#f97316;
display:flex;
align-items:center;
justify-content:center;
border-radius:50%;
}

.task-box{
border:1px dashed #ddd;
padding:8px;
border-radius:6px;
display:flex;
justify-content:space-between;
margin-bottom:10px;
}

.task-icon{
background:#d1fae5;
color:#10b981;
padding:6px;
border-radius:50%;
margin-right:5px;
}

.avatar-group img{
width:24px;
height:24px;
border-radius:50%;
border:2px solid #fff;
margin-left:-6px;
}

.more{
background:#f97316;
color:#fff;
padding:2px 6px;
border-radius:20px;
font-size:12px;
margin-left:5px;
}

.time-box{
background:#e5edf0;
padding:8px;
border-radius:6px;
display:flex;
justify-content:space-between;
}

`}</style>

</Card>

)

}